<div id="accessCodeModal" class="modal">
  <div
    class="modal-center-content mx-auto pt-4 px-4 px-lg-5 pb-5"
    style="border-radius: 10px !important"
  >
    <div class="d-flex justify-content-end">
      <img
        style="cursor: pointer"
        class="mb-4"
        (click)="toggleModal('accessCodeModal', 'close')"
        src="/assets/img/dismiss.svg"
        alt=""
      />
    </div>
    <!-- <form [formGroup]="accessForm" (ngSubmit)="loginToEvent()">
    <h6 style="color: #54595e; font-size: 17px" class="text-center mb-4">
      Enter event access code
    </h6>

     <div class="form-group d-block mb-3">
                       <label  for="guestCode">Guest Code <span class="text-danger">*</span></label>
                       <input formControlName="guestCode" type="text" id="guestCode" class="form-control w-100 auth-input  py-3 {{
                                       isInvalid('guestCode') ? 'error-input' : ''
                                     }}"  placeholder="Enter guest code to the event">
                       <div class="text-danger"  *ngIf="isInvalid('guestCode')">
                           <small>{{ getErrorMessage('guestCode', 'This field is required') }}</small>

                       </div>
                   </div>

     <div class="form-group d-block">
                       <label  for="guestEmail">Enter email <span class="text-danger">*</span></label>
                       <input formControlName="email" type="text" id="guestEmail" class="form-control w-100 auth-input  py-3  {{
                                       isInvalid('guestCode') ? 'error-input' : ''
                                     }}"  placeholder="Enter your email address">
                       <div class="text-danger"   *ngIf="isInvalid('email')">
                           <small>{{ getErrorMessage('email', 'This field is required') }}</small>
                       </div>
                   </div>

    <button type="submit" [disabled]="accessForm.invalid || requestLoading" class="btn btn-auth mt-0 mt-4">
                <object *ngIf="requestLoading" height="25"  data="/assets/img/button-loader.svg" type="image/svg+xml"></object>
                <span *ngIf="!requestLoading" style="font-weight: 500 !important; text-transform: none !important;">Continue</span>
            </button>
    </form> -->

    <form [formGroup]="accessForm" (ngSubmit)="loginToEvent()">
    <h6 style="color: #54595e; font-size: 17px" class="text-center mb-4">
      Enter event access code
    </h6>
     <div class="form-group d-block mb-3">
                       <label  for="guestCode">Guest Code <span class="text-danger">*</span></label>
                       <input formControlName="guestCode" type="text" id="guestCode" class="form-control w-100 auth-input  py-3 {{
                                       isInvalid('guestCode') ? 'error-input' : ''
                                     }}"  placeholder="Enter guest code to the event">
                       <div class="text-danger"  *ngIf="isInvalid('guestCode')">
                           <small>{{ getErrorMessage('guestCode', 'This field is required') }}</small>

                       </div>
                       <p (click)="closeCurrentModalAndOpenNewModal('accessCodeModal', 'forgotModal')" class="py-2" style="color: var(--theme-color1); font-size: 15px; font-weight: 600; cursor: pointer; text-align: right;">Forgot access code?</p>
                   </div>

    <button type="submit" [disabled]="accessForm.invalid || requestLoading" class="btn btn-auth mt-0 mt-4">
                <object *ngIf="requestLoading" height="25"  data="/assets/img/button-loader.svg" type="image/svg+xml"></object>
                <span *ngIf="!requestLoading" style="font-weight: 500 !important; text-transform: none !important;">Continue</span>
            </button>
    </form>
  </div>
</div>

<div id="forgotModal" class="modal">
  <div
    class="modal-center-content mx-auto pt-4 px-4 px-lg-5 pb-5"
    style="border-radius: 10px !important"
  >
    <div class="d-flex justify-content-end">
      <img
        style="cursor: pointer"
        class="mb-4"
        (click)="toggleModal('forgotModal', 'close')"
        src="/assets/img/dismiss.svg"
        alt=""
      />
    </div>

    <form [formGroup]="forgotForm" (ngSubmit)="getGuestEvents()">
      <div>

        <h6 style="color: #54595e; font-size: 17px" class="text-center">
          Forgot access code?
        </h6>
        <p class="text-center mb-4">Enter your email to view events you have access to</p>
      </div>
     <div class="form-group d-block mb-3">
                       <label  for="email">Email <span class="text-danger">*</span></label>
                       <input formControlName="email" type="text" id="email" class="form-control w-100 auth-input  py-3 {{
                                       isInvalidForgot('email') ? 'error-input' : ''
                                     }}"  placeholder="Enter your email address">
                       <div class="text-danger"  *ngIf="isInvalidForgot('email')">
                           <small>{{ getErrorMessageForgot('email', 'This field is required') }}</small>

                       </div>
                   </div>

    <button type="submit" [disabled]="forgotForm.invalid || requestLoading" class="btn btn-auth mt-0 mt-4">
                <object *ngIf="requestLoading" height="25"  data="/assets/img/button-loader.svg" type="image/svg+xml"></object>
                <span *ngIf="!requestLoading" style="font-weight: 500 !important; text-transform: none !important;">Continue</span>
            </button>
    </form>
  </div>
</div>

<div id="verifyEmailModal" class="modal">
  <div
    class="modal-center-content mx-auto pt-4 px-4 px-lg-5 pb-5"
    style="border-radius: 10px !important"
  >
    <div class="d-flex justify-content-end">
      <img
        style="cursor: pointer"
        class="mb-5"
        (click)="toggleModal('verifyEmailModal', 'close')"
        src="/assets/img/dismiss.svg"
        alt=""
      />
    </div>
    <div class="mb-5">

      <h6 style="color: #54595e; font-size: 17px" class="text-center mb-2">
  Enter OTP to access event
      </h6>
  
      <p class="text-center">Your OTP has been sent to {{maskedEmail}} Please check.</p>
    </div>
  <!-- <form class=""  [formGroup]="form"> -->
  <form class=""  [formGroup]="form" (ngSubmit)="verifyOTP()">
            <div class="d-flex align-items-center justify-content-center mb-4">
                <input id="codeBox1" type="tel" pattern="[0-9]*"  maxlength="1" (keyup)="onKeyUpEvent(1, $event)"  (focus)="onFocusEvent(1)" formControlName="input1" class="form-control auth-input py-3 mr-3">
                <input id="codeBox2" type="tel" pattern="[0-9]*"  maxlength="1" (keyup)="onKeyUpEvent(2, $event)" (focus)="onFocusEvent(2)" formControlName="input2" class="form-control auth-input py-3 mr-3">
                <input id="codeBox3" type="tel" pattern="[0-9]*"  maxlength="1" (keyup)="onKeyUpEvent(3, $event)" (focus)="onFocusEvent(3)" formControlName="input3" class="form-control auth-input py-3 mr-3">
                <input id="codeBox4" type="tel" pattern="[0-9]*"  maxlength="1" (keyup)="onKeyUpEvent(4, $event)" (focus)="onFocusEvent(4)" formControlName="input4" class="form-control auth-input py-3 mr-3">
                <input id="codeBox5" type="tel" pattern="[0-9]*"  maxlength="1" (keyup)="onKeyUpEvent(5, $event)" (focus)="onFocusEvent(5)" formControlName="input5" class="form-control auth-input py-3 mr-3">
                <input id="codeBox6" type="tel" pattern="[0-9]*"  maxlength="1" (keyup)="onKeyUpEvent(6, $event)" (focus)="onFocusEvent(6)" formControlName="input6" class="form-control auth-input py-3 mr-3">
            </div>
            <div class="d-flex justify-content-start align-items-center py-2">
                <small class="d-block" (click)="resendOTP()" style="cursor: pointer; font-size: 14px;">Resend OTP</small>
            </div>
            <!-- <button  (click)="closeCurrentModalAndOpenNewModal('verifyEmailModal', 'guestAddedModal')" type="submit" class="btn btn-auth mt-0 mt-4"> -->
            <button type="submit" [disabled]="form.invalid || requestLoading" class="btn btn-auth mt-0 mt-4">
                <object *ngIf="requestLoading" height="25"  data="/assets/img/button-loader.svg" type="image/svg+xml"></object>
                <span *ngIf="!requestLoading" style="font-weight: 500 !important; text-transform: none !important;">Verify</span>
            </button>
        </form>
  </div>
</div>





<div id="guestAddedModal" class="modal">
  <div
    class="modal-center-content mx-auto pt-4 px-4 px-lg-5 pb-5"
    style="border-radius: 10px !important"
  >
    <div class="d-flex justify-content-end">
      <img
        style="cursor: pointer"
        class="mb-4"
        (click)="toggleModal('guestAddedModal', 'close')"
        src="/assets/img/dismiss.svg"
        alt=""
      />
    </div>
    <img class="d-block mx-auto" src="/assets/img/success.svg" alt="" />
    <h6 style="color: #54595e; font-size: 17px" class="text-center mb-4">
      Guest successfully added!
    </h6>
 
    <button
      (click)="gotoDashboard()"
      class="btn btn-auth"
      style="text-transform: none"
    >
      Continue
    </button>
  </div>
</div>

<div id="eventsModal" class="modal">
  <div
    class="modal-center-content mx-auto pt-4 px-4 px-lg-5 pb-5"
    style="border-radius: 10px !important"
  >
    <div class="d-flex justify-content-end">
      <img
        style="cursor: pointer"
        class="mb-4"
        (click)="toggleModal('eventsModal', 'close')"
        src="/assets/img/dismiss.svg"
        alt=""
      />
    </div>
    <h6 style="color: #54595e; font-size: 17px" class="text-center mb-2">
  Your events
      </h6>
         <div class="bg-white mb-3">
<section *ngFor="let event of events" class="" style="border-top: 1px solid #FFE5D1">

    <div class="d-flex justify-content-start align-items-stretch mb-3 mt-3">
  <img
    [src]="event?.eventDetails?.images?.mainImage || '/assets/img/fallback-image.png'"
    alt="Event Image"
    class="event-image mr-3 h-100"
  />
  <div class="event-details flex-grow-1">
    <div class="d-flex justify-content-between">
      <div>
        <p class="mb-0 event-type">{{ capitalizeFirstLetter(event?.eventDetails?.type) }}</p>
        <p class="mb-1 event-name">{{ event?.eventDetails?.eventName }}</p>
        <div>
          <p class="mb-0 from-text mr-3">Access Code: {{ event?.guestCode }}</p>
        </div>
      </div>
      <div class="event-date d-block text-center align-items-center">
        <p class="mb-0 me-2 day">{{ getDay(event?.eventDetails?.eventDate) }}</p>
        <p class="mb-0 month">{{ getMonth(event?.eventDetails?.eventDate) }}</p>
      </div>
    </div>
    <div class="detail-login m-0">
      <small class="mr-3" style="color: #808080; font-size: 13px">
        <img
          [src]="
            event?.eventDetails?.access == 'public'
              ? '/assets/img/public-icon.svg'
              : '/assets/img/private-icon.svg'
          "
          class="mt-n1 mr-1"
          alt=""
        />
        <span
          [innerHTML]="
            event?.eventDetails?.access == 'public' ? 'Public' : 'Private'
          "
        ></span>
        event
      </small>
      <button class="btn view-details-btn" (click)="loginAsGuest(event?.guestCode)">
        <object
          *ngIf="requestLoading"
          height="25"
          data="/assets/img/button-loader.svg"
          type="image/svg+xml"
        ></object>
        <span *ngIf="!requestLoading" style="font-weight: 500 !important; text-transform: none !important;">
          Login as guest
        </span>
      </button>
    </div>
  </div>
</div>

</section>


            </div>
           
 
    <!-- <button
      (click)="gotoDashboard()"
      class="btn btn-auth"
      style="text-transform: none"
    >
      Continue
    </button> -->
  </div>
</div>